import { useClerk as useClerkReact } from "@clerk/clerk-react";
import { useClerk as useClerkRemix } from "@clerk/remix";

// If Clerk throws an error (e.g., not wrapped in ClerkProvider),
// return null instead of crashing -- this hook can be removed once
// we remove the "clerk-auth" feature flag and can just use useClerk() directly

/*
  Exception we're temporarily suppressing:

  Clerk not available: Error: useClerk can only be used within the <ClerkProvider /> component.

  Possible fixes:
  1. Ensure that the <ClerkProvider /> is correctly wrapping your application where this component is used.
  2. Check for multiple versions of the `@clerk/shared` package in your project. Use a tool like `npm ls @clerk/shared` to identify multiple versions, and update your dependencies to only rely on one.
*/
export function useSafeClerkRemix() {
  try {
    return useClerkRemix();
  } catch {
    return null;
  }
}

export function useSafeClerkReact() {
  try {
    return useClerkReact();
  } catch {
    return null;
  }
}
